export const SCROLL_EDGE_THRESHOLD_PX = 2;

export type HorizontalScrollState = {
  showPrev: boolean;
  showNext: boolean;
  canScroll: boolean;
  atStart: boolean;
  atEnd: boolean;
};

export const getHorizontalScrollState = (
  element: Pick<HTMLElement, 'scrollLeft' | 'scrollWidth' | 'clientWidth'>,
  threshold = SCROLL_EDGE_THRESHOLD_PX
): HorizontalScrollState => {
  const maxScrollLeft = element.scrollWidth - element.clientWidth;
  const atStart = element.scrollLeft <= threshold;
  const atEnd = maxScrollLeft - element.scrollLeft <= threshold;

  return {
    showPrev: !atStart,
    showNext: !atEnd && maxScrollLeft > threshold,
    canScroll: maxScrollLeft > threshold,
    atStart,
    atEnd,
  };
};

export const getHorizontalScrollStep = (clientWidth: number) =>
  Math.max(120, Math.round(clientWidth * 0.5));

export const getVerticalWheelScrollDelta = (
  event: Pick<WheelEvent, 'deltaX' | 'deltaY'>,
  state: Pick<HorizontalScrollState, 'canScroll' | 'atStart' | 'atEnd'>
) => {
  if (Math.abs(event.deltaY) <= Math.abs(event.deltaX) || !state.canScroll) {
    return null;
  }

  if (
    (event.deltaY > 0 && state.atEnd) ||
    (event.deltaY < 0 && state.atStart)
  ) {
    return null;
  }

  return event.deltaY;
};
